/** Staff CRM lists whose page frame must fill the viewport so the list can scroll. */
const STAFF_LIST_PREFIXES = [
  '/donors-list',
  '/reminders-list',
  '/paymentslist',
  '/pledges-list',
  '/rec-payments-list',
  '/rec-pledges-list',
  '/parents-list',
  '/students-list',
  '/school-payments',
  '/school-charges',
  '/school-recurring-payments',
  '/school-recurring-charges',
]

export function isStaffListPath(pathname: string): boolean {
  return STAFF_LIST_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
}
